import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

interface IProps {
  children: ReactNode;
}

interface IInfoPayment {
  pregeneratePolicyId?: string;
  checkout?: {
    sessionTransaction: string;
    plan?: {
      checkoutUrl: string;
    };
    [key: string]: any;
  };
}

type IContext = {
  step: number;
  infoPayment: IInfoPayment | null;
  formData: any;
  setStep: Dispatch<SetStateAction<number>>;
  setInfoPayment: Dispatch<SetStateAction<IInfoPayment | null>>;
  setFormData: Dispatch<SetStateAction<any>>;
  handleInitialState: () => void;
  resetFormCallback: (() => void) | null;
  setResetFormCallback: Dispatch<SetStateAction<(() => void) | null>>;
};

export const CreateSimplyKioskoContext = React.createContext<IContext>(
  {} as IContext,
);

export const useCreateSimplyKioskoContext = () =>
  useContext<IContext>(CreateSimplyKioskoContext);

const CreateSimplyKioskoProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [infoPayment, setInfoPayment] = useState<IInfoPayment | null>(null);
  const [formData, setFormData] = useState<any>(null);
  const [resetFormCallback, setResetFormCallback] = useState<
    (() => void) | null
  >(null);

  const handleInitialState = () => {
    setStep(1);
    setInfoPayment(null);
    setFormData(null);
    if (resetFormCallback) {
      resetFormCallback();
    }
  };

  const context: IContext = useMemo(
    () => ({
      step,
      infoPayment,
      formData,
      setStep,
      setInfoPayment,
      setFormData,
      handleInitialState,
      resetFormCallback,
      setResetFormCallback,
    }),
    [step, infoPayment, formData, resetFormCallback],
  );

  return (
    <CreateSimplyKioskoContext.Provider value={context}>
      {children}
    </CreateSimplyKioskoContext.Provider>
  );
};

export default CreateSimplyKioskoProvider;
